import { Box } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Form, Modal, TextAreaForm } from 'uikit'
import * as Yup from 'yup'
import { useEnableUser } from './services/useEnableUser'
import { Field, Formik } from 'formik'

const validationSchema = Yup.object({
  userComment: Yup.string().required('Обязательное поле'),
})

export const ActivateUser = ({ userId }) => {
  const { mutate, isLoading } = useEnableUser(userId)
  const [isOpen, setOpenModal] = useBoolean(false)

  const onSubmitHandle = (values) => {
    mutate(values)
  }

  return (
    <>
      <Button
        width="100%"
        onClick={() => setOpenModal(true)}
        colorPalette="blue"
        variant="outline"
        loading={isLoading}
      >
        Активировать
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Активировать пользователя">
        <Formik
          validateOnMount
          enableReinitialize
          initialValues={{}}
          validationSchema={validationSchema}
          onSubmit={onSubmitHandle}
        >
          {({ handleSubmit, isValid }) => (
            <Form w="full">
              <Field
                disabled={isLoading}
                name="userComment"
                placeholder="Введите комментарий"
                component={TextAreaForm}
              />
              <Box pt="30px">
                <Button
                  colorPalette="orange"
                  loading={isLoading}
                  onClick={handleSubmit}
                  disabled={!isValid}
                >
                  Активировать
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}
